import { colorPalette } from '@atlaskit/adf-schema';
import getColorMessage from './getColorMessage';
import paletteMessages from './paletteMessages';
export var mapPaletteColor = function mapPaletteColor(label, color) {
  var key = label.toLowerCase().replace(' ', '-');
  var message = getColorMessage(paletteMessages, key);
  return {
    value: color,
    label: label,
    border: "var(--ds-border, #091E4224)",
    message: message
  };
};

// row 1
export var textColorPalette = [];
export var textColorPaletteTokenBorders = [];
colorPalette.forEach(function (label, color) {
  textColorPalette.push(mapPaletteColor(label, color));
});